import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';
import listsReducersMap from './lists/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('localeModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/reducers/static/combineRegistry.js